import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import dayjs from "dayjs";
import { scrollbarStyle } from "../../../scrollbarStyle";
import { useState } from "react";
import { EditExamDialog } from "../EditExamDialog/EditExamDialog";
import { ExamResult } from "../../hooks/types";

interface ExamTableProps {
  exams: ExamResult[];
  onEdit: (index: number) => void;
  onDelete: (identifier: string) => void;
  handleOpenEditDialog: (exam: ExamResult) => void;
}

export const ExamTable = ({ exams, onEdit, onDelete, handleOpenEditDialog }: ExamTableProps) => {
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "400px",
          overflowX: "auto",
          ...scrollbarStyle,
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Data</TableCell>
              <TableCell align="center">Valor</TableCell>
              <TableCell align="center">Unidade</TableCell>
              <TableCell align="right">Médico</TableCell>
              <TableCell align="center" sx={{ width: "100px" }}>
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {exams.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  Nenhum resultado cadastrado
                </TableCell>
              </TableRow>
            ) : (
              exams
                .filter((exam) => exam.item[2]?.answer?.[0]?.valueDate)
                .sort((a, b) => dayjs(b.answerDate).diff(dayjs(a.answerDate)))
                .map((exam, index) => {
                  const unitItem = exam.item?.find(
                    (item) => item.text === "Unidade"
                  );

                  let unitValue = "";
                  if (unitItem && unitItem.answer && unitItem.answer[0]?.valueString) {
                    unitValue = unitItem.answer[0].valueString;
                  } else {
                    const valueParts = exam.item[1]?.answer?.[0]?.valueString?.split(" ");
                    if (valueParts && valueParts.length > 1) {
                      unitValue = valueParts[1];
                    }
                  }

                  return (
                    <TableRow
                      key={`${exam.displayInfo?.identifier}-${exam.answerDate
                        }-${index}-${Math.random()}`}
                      hover
                    >
                      <TableCell>
                        {exam.item[2]?.answer?.[0]?.valueDate
                          ? dayjs(exam.item[2]?.answer?.[0]?.valueDate).format(
                            "DD/MM/YY"
                          )
                          : ""}
                      </TableCell>
                      <TableCell align="center">
                        {exam.item[1]?.answer?.[0]?.valueString}
                      </TableCell>
                      <TableCell align="center">
                        {unitValue}
                      </TableCell>
                      <TableCell align="right">
                        {exam.displayInfo?.practitioner && (
                          <Tooltip
                            title={
                              exam.displayInfo.healthcare || "Sem especialidade"
                            }
                          >
                            <Typography variant="body2">
                              Dr. {exam.displayInfo.practitioner}
                            </Typography>
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell align="center" sx={{ width: "100px" }}>
                        <Stack
                          direction="row"
                          spacing={1}
                          justifyContent="center"
                        >
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenEditDialog(exam);
                            }}
                            color="primary"
                          >
                            <Edit fontSize="small" />
                          </IconButton>

                          {exam.displayInfo?.healthcare === "Inserção Manual" && (
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                onDelete(exam.displayInfo.identifier);
                              }}
                              sx={{ color: "error.main" }}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          )}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
